
<template>
  <div class="login-wrapper">
    <div class="navigations">
      <ul>
        <li
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ active: index == chooseIndex }"
          @click="tabChange(item, index)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="me_nav" v-if="chooseIndex === 1">
        <ul>
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="{ actives: index == navIndex }"
            @click="tabNav(item, index)"
          >
            {{ item }}
          </li>
        </ul>
        <div>
          <div class="searchs">
            <img
              v-show="isshow"
              src="../image/放大镜.png"
              alt
              @click="tosearchtime"
            />
            <img
              v-show="!isshow"
              src="../image/取消.png"
              alt
              @click="tosearchtime"
            />
            <!-- <img :src="i==0?searchs:cancel" alt=" "> -->
          </div>
        </div>
        <div class="search_result">
          <div class="search_result_back" v-if="isresets">
            <span class="search_result_conten"
              ><label class="search_lins"></label>搜索如下：<label
                class="search_result_record"
                >{{ orderList.length }}条记录</label
              ></span
            >
            <p @click="resets">重置</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="chooseIndex === 0">
      <div class="caredily-symbol">
        <div class="agent_msg">
          <div class="name">
            <img v-if="avatar" :src="avatar" alt="" />
            <img v-else src="../image/toux.png" alt="" />
          </div>
          <div class="agentid">
            <div>{{ name }} <span class="tabs">团长</span></div>
            <span type="primary" class="phone">{{ phones }}</span>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <div class="receipt-content">
          <!-- 商品区域 -->
          <div class="goods">
            <h3>商品</h3>
            <ul class="good-list">
              <li v-for="(item, index) in goodList" :key="index">
                <!-- <i class="delete" @click="deleteProduct(index)"></i> -->
                <div class="good-img">
                  <img :src="item.image" alt="" />
                </div>
                <div class="good-msg">
                  <p class="good-name">{{ item.product_name }}</p>
                  <div class="good-num">
                    <p>
                      <span class="sku-name"
                        >规格：{{ item.skuname }}|{{ item.unit }}</span
                      >
                    </p>
                    <div class="sku_pirce">
                      <span
                        class="sku_pirce_txt"
                        v-if="
                          oagentId !== '' &&
                          oagentId !== 'undefined' &&
                          item.price != null &&
                          item.price !== undefined
                        "
                        >单价：{{ item.price }}</span
                      >
                      <p>
                        <span class="sku-num"
                          ><label @click="addcount(1, index)">-</label
                          ><b>{{ item.count }}</b
                          ><label @click="addcount(2, index)">+</label></span
                        >
                        <i class="delete" @click="deleteProduct(index)"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="add-button" @click="addGood">
              <img src="../image/Tj.png" alt="" />
              <span v-if="goodList.length === 0">添加商品</span>
              <span v-else>继续添加商品</span>
            </div>
          </div>
          <!-- 地址区域 -->
          <div class="address">
            <h3>地址</h3>
            <div
              class="add-button"
              @click="addAddr"
              v-if="JSON.stringify(this.addrRecord) === '{}'"
            >
              <img src="../image/Tj.png" alt="" />
              <span>添加地址</span>
            </div>
            <div class="address-msg" @click="addAddr" v-else>
              <i class="left"></i>
              <div class="msg">
                <p>
                  <span>收货人：{{ contacts }}</span>
                  <span>{{ phone }}</span>
                </p>
                <p>{{ address }}{{ detailedAddress }}</p>
              </div>
              <i class="right"></i>
            </div>
          </div>
          <!-- 备注区域 -->
          <div class="remark">
            <h3>备注</h3>
            <div v-if="remarkText" class="remark-text" @click="addRemark">
              <p>{{ remarkText }}</p>
            </div>
            <div v-else class="add-button" @click="addRemark">
              <img src="../image/Tj.png" alt="" />
              <span>添加备注</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部确定按钮 -->
      <div class="fixed-button btn_flex">
        <div
          class="total_price"
          v-if="oagentId !== '' && oagentId !== 'undefined'"
        >
          总金额：
          <p>
            ￥<label>{{ totalPrice }}</label>
          </p>
        </div>
        <van-button @click="sumbitAll" :loading="loading">提交</van-button>
      </div>
    </div>
    <div class="me_con" v-if="chooseIndex === 1">
      <div class="orderList">
        <ul>
          <li v-for="(item, index) in orderList" :key="index">
            <span class="lines"></span>
            <div class="order_num">
              <div class="numbers">
                <span class="numbers_txt"
                  ><label class="texts">订单号：</label
                  ><label class="text_num">{{ item._id }}</label
                  ><img src="../image/1@2x.png"
                /></span>
                <p @click="copy(item._id)">复制</p>
              </div>
              <p class="order_time">下单时间：{{ item.create_at }}</p>
            </div>
            <div class="colonel" v-if="item.name">
              <span class="colonel_name">{{ item.name }}</span>
              <span class="colonel_tag">团长</span>
              <span class="colonel_phone">{{ item.agent_phone }}</span>
            </div>
            <div class="colonel me_colonel">
              <span class="colonel_name">{{ item.contacts }}</span>
              <span class="colonel_tag">收货人</span>
              <span class="colonel_phone">{{ item.phone }}</span>
            </div>
            <div class="oeder_addres">
              <div class="addres_txts">
                <div class="address_con">
                  <img src="../image/Dw@2x.png" />{{ item.province
                  }}{{ item.city }}{{ item.area }}{{ item.addr }}
                </div>
              </div>
            </div>
            <div class="refuse" v-if="navIndex === 2">
              <p v-if="item.reject_remark">
                拒绝原因：{{ item.reject_remark }}
              </p>
              <p class="refuse_time">
                拒绝时间：{{ new Date(item.update_at).toLocaleString() }}
              </p>
            </div>
            <div class="refuse" v-if="navIndex === 0 && item.sys_remark">
              <p>拒绝原因：{{ item.sys_remark }}</p>
            </div>

            <div class="logistics_list" v-if="item.logistics">
              <div
                class="logisticsList"
                v-for="(items, indexs) in item.logistics"
                :key="indexs"
              >
                <div class="logisticsTitle">
                  <p class="logisticsName">
                    <label>{{ items.shipperName }}</label> 单号：{{
                      items.logistic_code
                    }}
                  </p>
                  <p
                    class="copy_logistics"
                    @click="looklogistices(item, indexs)"
                  >
                    查看物流
                  </p>
                </div>
                <div class="logistics_msg">
                  <p class="logistics_line">
                    <span class="reds"></span>
                    <span class="whites"></span>
                    <span class="blues"></span>
                    <span class="whites"></span>
                    <span class="reds"></span>
                    <span class="whites"></span>
                    <span class="blues"></span>
                    <span class="whites"></span>
                    <span class="reds"></span>
                    <span class="whites"></span>
                    <span class="blues"></span>
                    <span class="whites"></span>
                    <span class="reds"></span>
                    <span class="whites"></span>
                    <span class="blues"></span>
                    <span class="whites"></span>
                    <span class="reds"></span>
                    <span class="whites"></span>
                    <span class="blues"></span>
                    <span class="whites"></span>
                    <span class="reds"></span>
                    <span class="whites"></span>
                    <span class="blues"></span>
                    <span class="whites"></span>
                    <span class="reds"></span>
                    <span class="whites"></span>
                    <span class="blues"></span>
                  </p>
                  <div class="logistics_list_con">
                    {{ items.traces[items.traces.length - 1].accept_station }}
                    <p>
                      {{ items.traces[items.traces.length - 1].accept_time }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="order_btn">
              <van-button @click="Detail(index)">订单详情</van-button>
            </div>
          </li>
        </ul>
      </div>
      <div class="subordinate" v-if="orderList.length == 0">
        <img src="..//image/Sj.png" alt="" />
        <p>暂无数据</p>
      </div>
      <div v-show="!empty && orderList.length != 0" class="more-w">
        <span @click="loadBottom">点击加载更多...</span>
      </div>
      <div v-show="empty && orderList.length != 0" class="more-w">
        没有更多了
      </div>
    </div>
    <!-- 添加商品弹窗 -->
    <van-popup
      v-model="goodPopupVisible"
      :style="{ height: '70%' }"
      position="bottom"
    >
      <div class="popupBox">
        <h2>添加商品</h2>
        <!-- <div class="searchText">
          <i></i>
          <input type="serch" v-model="input" @keypress="searchGoods" placeholder="请输入搜索的商品">
        </div> -->
        <div class="product">
          <!-- <h4>商品列表：</h4> -->
          <ul class="product-list">
            <li
              v-for="(item, index) in productList"
              :key="index"
              @click="openSku(item, index)"
            >
              <div class="checked">
                <i
                  :class="productActiveIndex === index ? 'active' : 'nocheck'"
                  @click="openSku(item, index)"
                ></i>
              </div>
              <img :src="item.thumbnail" alt="" />
              <div class="product-msg">
                <p class="product-name">{{ item.name }}</p>
                <!-- <p class="product-sub">柔润以待，净宠宝贝肌</p> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
    <!-- 添加sku弹窗 -->
    <van-popup v-model="skuShow" :style="{ height: '70%' }" position="bottom">
      <div class="popupBox" style="padding-bottom: 80px">
        <div class="title">
          <h3>商品详情</h3>
          <i @click="skuShow = false"></i>
        </div>
        <div class="product-img">
          <img :src="currentProduct.thumbnail" alt="" />
          <div>
            <p>{{ currentProduct.name }}</p>
            <p
              class="product_pirce"
              v-if="
                oagentId !== '' &&
                oagentId !== 'undefined' &&
                skuList[skuActiveIndex] != undefined &&
                skuList[skuActiveIndex].price != null
              "
            >
              单价：{{ skuList[skuActiveIndex].price }}
            </p>
          </div>
        </div>
        <div class="product-sku">
          <p>规格</p>
          <ul class="sku-list">
            <li
              :class="skuActiveIndex === index ? 'active' : ''"
              v-for="(item, index) in skuList"
              :key="index"
              @click="chooseSku(item, index)"
            >
              {{ item.skuname }}|{{ item.unit }}
            </li>
          </ul>
        </div>
        <div class="product-num">
          <span class="text">数量</span>
          <div class="operation">
            <i class="reduce" @click="isRreduce('reduce')"></i>
            <input type="number" maxlength="6" v-model="count" />
            <i class="add" @click="isRreduce('add')"></i>
          </div>
        </div>
        <div class="fixed-button" @click="sumbitSku">
          <span>确定</span>
        </div>
      </div>
    </van-popup>
    <!-- 添加地址弹窗 -->
    <van-popup v-model="addrShow" :style="{ height: '72%' }" position="bottom">
      <div class="popupBox" style="padding-bottom: 80px">
        <div class="title">
          <h3>填写地址</h3>
          <i @click="addrShow = false"></i>
        </div>
        <div class="addr-input" :class="focusIndex === 0 ? 'active' : ''">
          <span>姓名</span>
          <input
            type="text"
            @focus="focusActive('name')"
            @blur="scrollTop"
            v-model="contacts"
            placeholder="请输入"
          />
        </div>
        <div class="addr-input" :class="focusIndex === 1 ? 'active' : ''">
          <span>手机号</span>
          <input
            type="number"
            @focus="focusActive('phone')"
            @blur="scrollTop"
            v-model="phone"
            placeholder="请输入"
          />
        </div>
        <div
          class="addr-input-choose"
          :class="focusIndex === 2 ? 'active' : ''"
          @click="chooseProvinces"
        >
          <span>所在地</span>
          <span v-if="!address" class="input">请选择</span>
          <span v-else class="input">{{ address }}</span>
          <i></i>
        </div>
        <div class="addr-input-del" :class="focusIndex === 3 ? 'active' : ''">
          <p>详细地址</p>
          <textarea
            name=""
            id=""
            @focus="focusActive('detailedAddress')"
            @blur="scrollTop"
            v-model="detailedAddress"
            placeholder="请输入"
          ></textarea>
        </div>
        <div class="fixed-button" @click="sumbitTake">
          <span>确定</span>
        </div>
      </div>
    </van-popup>
    <!-- 添加备注弹窗 -->
    <van-popup
      v-model="remarkShow"
      :style="{ height: '60%' }"
      position="bottom"
    >
      <div class="popupBox" style="padding-bottom: 80px">
        <div class="title remark-title">
          <h2>备注：</h2>
          <i @click="remarkShow = false"></i>
        </div>
        <div class="remark-input-del">
          <textarea
            name=""
            id=""
            @blur="scrollTop"
            v-model="remark"
            placeholder="请输入"
          ></textarea>
        </div>
        <div class="fixed-button" @click="sumbitRemark">
          <span>确定</span>
        </div>
      </div>
    </van-popup>
    <!-- 提交订单后弹框 -->
    <van-dialog
      v-model="succeeds"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="showtan">
        <i @click="succeeds = false"></i>
        <p class="img_con">
          <img src="../image/Pt_Img@2x.png" />
        </p>
        <div class="hitsucceed_txt">提交成功</div>
        <p
          class="title titles"
          v-if="oagentId !== '' && oagentId !== 'undefined'"
        >
          总金额为：{{ totalPrices }}
        </p>
        <div class="hit_txt">请自行与团长结算</div>
        <div class="show_btns">
          <!-- <van-button @click="orderlist">确定</van-button> -->
        </div>
      </div>
    </van-dialog>
    <!-- 提交订单后弹框 -->
    <van-dialog
      v-model="errds"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="showtan">
        <i @click="errds = false"></i>

        <p class="title titles">{{ errmessage }}</p>
        <div class="show_btns">
          <van-button @click="errds = false">确定</van-button>
        </div>
      </div>
    </van-dialog>

    <!-- 订单详情 -->
    <van-popup v-model="ordershow" :style="{ height: '72%' }" position="bottom">
      <div class="popupBox order_pop" style="padding-bottom: 80px">
        <div class="title">
          <h3>订单详情</h3>
          <i @click="ordershow = false"></i>
        </div>
        <ul class="order_detail">
          <li v-for="(item, index) in orderdetailes.product_list" :key="index">
            <div class="shopimg">
              <img :src="item.image" />
            </div>
            <div class="order_detail_con">
              <p class="shop_name">
                {{ item.product_name }}
              </p>
              <p class="specification">规格：{{ item.sku_name }}</p>
              <div class="shop_pirce">
                <p v-if="oagentId !== '' && oagentId !== 'undefined'">
                  单价：{{ item.price }}
                </p>
                <p>{{ item.count }}{{ item.unit }}</p>
              </div>
            </div>
          </li>
        </ul>
        <div
          class="order_amount"
          v-if="
            oagentId !== '' && oagentId !== 'undefined' && orderdetailes.total
          "
        >
          <span>总金额：<label>￥</label></span>
          <label>{{ orderdetailes.total }}</label>
        </div>
      </div>
    </van-popup>

    <!-- 查看物流 -->
    <van-popup
      v-model="islogistics"
      :style="{ height: '72%' }"
      position="bottom"
      class="logistics_pop"
    >
      <div class="popupBox order_pop" style="padding-bottom: 80px">
        <div class="title">
          <h3>物流信息</h3>
          <i @click="islogistics = false"></i>
        </div>
        <div
          class="expressage"
          v-if="locitem.logistics != undefined && locitem.logistics != null"
        >
          <div class="expressage_txt">
            <p class="expressage_name">
              {{ locitem.logistics[locindex].shipperName }}
              <span class="lines"></span>
            </p>
            <p class="expressage_line"></p>
            <p class="expressage_numtxt">物流单号</p>
            <p class="expressage_name expressage_nums">
              {{ locitem.logistics[locindex].logistic_code }}
            </p>
          </div>
          <span>复制</span>
        </div>

        <ul
          class="order_detail"
          v-if="locitem.logistics != undefined && locitem.logistics != null"
        >
          <li>
            <div class="shopimg">
              <img
                :src="productInfo[locitem.logistics[locindex].sku_id].image"
              />
            </div>
            <div class="order_detail_con">
              <p class="shop_name">
                {{
                  productInfo[locitem.logistics[locindex].sku_id].product_name
                }}
              </p>
              <p class="specification">
                规格：{{
                  productInfo[locitem.logistics[locindex].sku_id].sku_name
                }}
              </p>
              <div
                class="shop_pirce"
                v-if="oagentId !== '' && oagentId !== 'undefined'"
              >
                <p>
                  单价：{{
                    productInfo[locitem.logistics[locindex].sku_id].price

                  }}
                </p>
                <p>
                  {{ locitem.logistics[locindex].count
                  }}{{ productInfo[locitem.logistics[locindex].sku_id].unit }}
                </p>
              </div>
            </div>
          </li>
          <li>
            <div class="logistics_stalker">
              <p class="stalker_title">物流跟踪</p>
            </div>
          </li>
          <li>
            <div>
              <van-steps direction="vertical" class="stepes">
                <van-step
                  v-for="(item, index) in locitem.logistics[locindex].traces"
                  :key="index"
                >
                  <div class="step">
                    <h3>
                      {{ item.accept_station }}
                    </h3>
                    <p>{{ item.accept_time }}</p>
                  </div>
                </van-step>
              </van-steps>
            </div>
          </li>
        </ul>
      </div>
    </van-popup>
    <!-- 搜索 -->
    <van-popup
      v-model="searchPopup"
      position="top"
      :style="{ top: '80px', borderRadius: 0 }"
    >
      <div class="searchPopups">
        <div class="search_con">
          <select name id v-model="education">
            <option value disabled>请选择</option>
            <option
              v-for="(item, index) in paywayList"
              :key="index"
              :value="item"
            >
              <span>{{ item }}</span>
            </option>
          </select>
          <van-field v-model="values" placeholder="请输入查询信息" />
        </div>
        <div class="search_btnBox">
          <van-button @click="surePwd">搜索</van-button>
        </div>
      </div>
    </van-popup>
    <address-temp :address-popup="addressPopup" @closePopup="closePopup" @getAddr="getAddr" :addr="addrList" />
  </div>
</template>

<script>
import http from '../common/http.js'
import https from '../common/https.js'
import logisticss from '../common/logistics.js'
import { Toast } from 'vant'
import AddressTemp from './common/address.vue'
// import axios from 'axios'
// import { Indicator } from 'mint-ui'
export default {
  components: { AddressTemp },
  name: 'receipt',
  data() {
    return {
      errds: false,
      isresets: false,
      totalPrice: 0,
      totalPrices: 0,
      education: '',
      values: '',
      searchPopup: false,
      islogistics: false,
      ordershow: false,
      isshow: true,
      succeeds: false,
      tabList: ['购物', '我的'],
      paywayList: ['昵称', '收货人', '手机号'],
      navList: ['待审核', '已审核', '已拒绝'],
      chooseIndex: 0,
      navIndex: 0,
      avatar: this.$route.query.avatar || '',
      name: this.$route.query.agent_name || '',
      agentId: this.$route.query.agent_id || '',
      phones: this.$route.query.phone || '',
      ophone: this.$route.query.o_a_phone || '',
      oname: this.$route.query.o_a_name || '',
      oagentId: this.$route.query.o_a_id || '',
      goodList: [],
      goodPopupVisible: false,
      input: '',
      productList: [],
      skuShow: false,
      count: 1,
      skuList: [],
      productActiveIndex: null,
      skuActiveIndex: 0,
      addrShow: false,
      addressPopup: false,
      province: '',
      city: '',
      area: '',
      town: '',
      address: '',
      contacts: '',
      phone: '',
      detailedAddress: '',
      remark: '',
      remarkText: '',
      remarkShow: false,
      currentProduct: {},
      currentSku: {},
      focusIndex: null,
      addrRecord: {},
      loading: false,
      skip: 0,
      limit: 10,
      orderList: [],
      empty: false,
      orderdetailes: {},
      locitem: {},
      locindex: 0,
      productInfo: {},
      changesindex: 0,
      querymsg: {},
      errmessage: '',
      province_code: '',
      city_code: '',
      area_code: '',
      town_code: '',
      addrList: []
    }
  },
  created() {
    let goodList = JSON.parse(localStorage.getItem('goodList'))

    if (goodList) {
      goodList.forEach((v) => {
        if (v.price) {
          this.totalPrice += v.count * v.price
        }
      })
      this.goodList = goodList
    } else {
      this.goodList = []
    }
    this.addrRecord = JSON.parse(localStorage.getItem('addr')) || {}
    let addr = this.addrRecord
    if (addr) {
      this.address = addr.province + addr.city + addr.area + addr.town
      this.contacts = addr.contacts
      this.phone = addr.phone
      this.province = addr.province
      this.province_code = addr.province_code
      this.city = addr.city
      this.city_code = addr.city_code
      this.area = addr.area
      this.area_code = addr.area_code
      this.town = addr.town
      this.town_code = addr.town_code
      this.addr = addr.detailedAddress
      this.detailedAddress = addr.detailedAddress
    }
    let remark = localStorage.getItem('remarkText')
    if (remark) {
      this.remarkText = remark
    }
  },

  mounted() {
    document.body.addEventListener('touchstart', function () {})
    this.iosScrollFix('login-wrapper')

    this.getProduct()
  },
  methods: {
    getAddr(adr) {
      this.address = ''
      this.addrList = adr
      adr.forEach(v => {
        this.address += v.n
        if (v.c.length === 2) {
          this.province = v.n
          this.province_code = v.c
        }
        if (v.c.length === 4) {
          this.city = v.n
          this.city_code = v.c
        }
        if (v.c.length === 6) {
          this.area = v.n
          this.area_code = v.c
        }
        if (v.c.length === 9) {
          this.town = v.n
          this.town_code = v.c
        }
      })
    },
    closePopup() {
      this.addressPopup = false
    },
    // iphone input 输入法 弹窗将页面顶起 解决办法
    scrollTop() {
      window.scrollTo(0, 0)
    },
    // 点击tab栏切换订单状态列表
    tabChange(item, index) {
      this.chooseIndex = index

      if (index === 1) {
        this.navIndex = 0
        this.orderList = []
        this.getOrderList('待审核', true)
      }
    },
    // 获取订单
    getOrderList(express, isSearch) {
      if (express === '已审核') {
        express = '已同意'
      }
      this.changesindex = this.orderList.length - 1
      var parse = ''
      if (this.querymsg.contacts) {
        parse = '&contacts=' + this.querymsg.contacts
      }
      if (this.querymsg.phone) {
        parse = '&phone=' + this.querymsg.phone
      }
      if (this.querymsg.nick_name) {
        parse = '&contacts=' + this.querymsg.nick_name
      }
      http
        .get(
          `holiday/public/collect/order/get/list/${this.$route.query.unionid}?state=${express}&skip=${this.skip}&limit=${this.limit}${parse}`
        )
        .then((res) => {
          if (res.code === 0) {
            if (res.data == null || res.changes < this.limit) {
              this.empty = true
            }
            if (res.data != null) {
              res.data.forEach((v) => {
                v.create_at = new Date(v.create_at).toLocaleString()
                if (!isSearch) {
                  this.orderList.push(v)
                }
                v.product_list.forEach((vv) => {
                  this.productInfo[vv.sku_id] = vv
                })
              })

              if (isSearch) {
                this.orderList = res.data
              }
              if (express === '已同意') {
                this.getlogistics()
              }
            }
          }
        })
    },

    // 订单详情
    Detail(index) {
      this.orderdetailes = this.orderList[index]
      this.ordershow = true
    },

    getlogistics() {
      this.orderList.forEach((v, index) => {
        if (this.changesindex <= index) {
          this.getlogisticses(v._id, index)
        }
      })
    },
    // 查看物流
    getlogisticses(ordeid, index) {
      // var neworderlist = this.orderList
      http.get(`logistics/public/logistic/order/list/${ordeid}`).then((res) => {
        if (res.code === 0 && res.data != null) {
          res.data.forEach((v, indexs) => {
            res.data[indexs].shipperName =
              logisticss[res.data[indexs].shipper_code]
            v.traces = v.traces.reverse()
          })
          this.orderList[index].logistics = []
          this.orderList[index].logistics = res.data
          this.orderList.push({})
          this.orderList.splice(this.orderList.length - 1, 1)
        }
      })
    },
    // 查看物流
    looklogistices(val, index) {
      this.locitem = val
      this.locindex = index
      this.islogistics = true
    },

    // 复制
    copy(orderid) {
      this.$copyText(orderid).then(
        () => {
          this.$toast('复制成功')
        },
        () => {
          // var s=e
          this.$toast('复制失败，请重新复制')
        }
      )
    },

    // 点击加载更多
    loadBottom() {
      this.skip += this.limit
      let express = this.navList[this.navIndex]
      this.getOrderList(express, false)
    },
    //  点击导航
    tabNav(item, index) {
      this.navIndex = index
      this.orderList = []
      this.empty = false
      this.skip = 0
      this.limit = 10
      this.getOrderList(item, true)
    },
    // 搜索
    surePwd() {
      if (this.education == '') {
        this.$toast('请选择查询条件')
        return
      }
      this.querymsg = {}
      if (this.education === '昵称') {
        this.querymsg.nick_name = this.values
      }
      if (this.education === '收货人') {
        this.querymsg.contacts = this.values
      }
      if (this.education === '手机号') {
        this.querymsg.phone = this.values
      }
      this.orderList = []
      this.isresets = true
      this.isshow = true
      this.searchPopup = false
      this.getOrderList(this.navList[this.navIndex], true)
    },
    // 重置
    resets() {
      this.querymsg = {}
      this.values = ''
      this.orderList = []
      this.isshow
      this.isresets = false
      this.getOrderList(this.navList[this.navIndex], true)
    },
    // 取消查询
    tocanceltime() {},
    // 点击查询
    tosearchtime() {
      if (this.isshow) {
        this.isshow = false
        this.searchPopup = true
      } else {
        this.isshow = true
        this.searchPopup = false
      }
    },
    // input输入框聚焦事件
    focusActive(type) {
      if (type === 'name') {
        this.focusIndex = 0
      }
      if (type === 'phone') {
        this.focusIndex = 1
      }
      if (type === 'detailedAddress') {
        this.focusIndex = 3
      }
    },
    // 获取商品列表
    getProduct() {
      https
        .get('library/public/products?categoryid=611b92e5c589686f19ec7cf5')
        .then((res) => {
          if (res.ok) {
            this.productList = res.data
          }
        })
    },
    // 添加商品
    addGood() {
      // http.divScroll(".mint-popup")
      // document.body.style.overflow = "hidden"
      this.goodPopupVisible = true
      this.productActiveIndex = null
    },
    // 加减商品
    addcount(vals, index) {
      if (vals === 1) {
        this.goodList[index].count -= 1
        if (this.goodList[index].count === 0) {
          this.goodList.splice(index, 1)
        }
      } else {
        this.goodList[index].count += 1
      }
      this.totalPrice = 0
      this.goodList.forEach((v) => {
        if (v.price) {
          this.totalPrice += v.count * v.price
        }
      })
      localStorage.setItem('goodList', JSON.stringify(this.goodList))
    },
    // 搜索商品
    searchGoods(event) {
      if (event.keyCode == 13) {
        event.preventDefault()
        // https.get('library/public/products?categoryid=5b11f1ee4966b476da419d35&name=' + this.input).then(res => {
        //   if (res.ok) {
        //     this.productList = res.data
        //   }
        // })
      }
    },
    // 删除商品
    deleteProduct(index) {
      this.goodList.splice(index, 1)
      localStorage.setItem('goodList', JSON.stringify(this.goodList))
    },
    // 勾选商品，打开sku弹窗
    openSku(item, index) {
      this.skuActiveIndex = 0
      this.productActiveIndex = index
      this.count = 1
      this.skuShow = true
      this.currentProduct = item
      this.getSkus(item._id)
    },
    // 获取sku列表
    getSkus(productId) {
      https.get(`library/public/skus?productid=${productId}`).then((res) => {
        if (res.ok) {
          this.skuList = res.data
          this.currentSku = this.skuList[0]
        }
      })
    },
    // 选择sku
    chooseSku(item, index) {
      this.skuActiveIndex = index
      this.count = 1
      this.currentSku = item
    },
    // 商品数量增减
    isRreduce(type) {
      if (type === 'add') {
        this.count++
      } else {
        this.count === 1 ? 1 : this.count--
      }
    },
    // 提交sku
    sumbitSku() {
      this.count = (this.count + '').replace(/\s/g, '')
      if (this.count.length > 6) {
        this.$toast('超出最大限制数量')
        return
      }
      this.goodPopupVisible = false
      this.skuShow = false
      this.currentSku.count = Number(this.count)
      this.currentSku.name = this.currentProduct.name
      this.currentSku.thumbnail = this.currentProduct.thumbnail
      this.currentSku.category = this.currentProduct.category
      this.goodList.push(this.currentSku)
      this.goodList = this.repeatFun(this.goodList)
      this.totalPrice = 0
      if (this.oagentId !== 'undefined') {
        this.goodList.forEach((v) => {
          if (v.price) {
            this.totalPrice += v.count * v.price
          }
        })
      }

      localStorage.setItem('goodList', JSON.stringify(this.goodList))
    },
    // 添加的商品去重
    repeatFun(list) {
      if (list != null) {
        let map = {},
          dest = []
        for (let i in list) {
          // list[i].editState = false
          let ai = list[i]
          if (!map[ai._id]) {
            dest.push(ai)
            map[ai._id] = ai
          } else {
            for (let j in dest) {
              let dj = dest[j]
              dj.count = Number(dj.count)
              if (dj._id === ai._id) {
                dj.count += Number(ai.count)
                break
              }
            }
          }
        }
        let obj = {}
        let orderdetail = []
        dest.forEach((v) => {
          obj = {
            product_name: v.name,
            count: v.count,
            image: v.thumbnail,
            product_id: v.productid,
            skuname: v.skuname,
            sku_name: v.skuname,
            sku_id: v._id,
            _id: v._id,
            name: v.name,
            thumbnail: v.thumbnail,
            productid: v.productid,
            unit: v.unit,
            category: v.category,
          }
          if (this.oagentId !== 'undefined') {
            obj.price = v.price
          }
          orderdetail.push(obj)
        })
        return orderdetail
      } else {
        return []
      }
    },
    // 添加地址
    addAddr() {
      // http.divScroll('.mint-popup')
      // document.body.style.overflow = 'hidden'
      if (JSON.stringify(this.addrRecord) === '{}') {
        // 没有添加过地址信息
        this.isModify = 0
        this.address = ''
        this.detailedAddress = ''
      }
      this.focusIndex = null
      this.addrShow = true
    },
    // 点击选择地址
    chooseProvinces() {
      this.addressPopup = true
    },
    // 地址确认
    sumbitAdr() {
      if (!this.city) {
        this.$toast('请选择市区')
        return
      }
      if (!this.area) {
        this.$toast('请选择区')
        return
      }
      this.addressPopup = false
    },
    // 提交填写的地址
    sumbitTake() {
      this.contacts = this.contacts.replace(/\s/g, '')
      if (!this.contacts) {
        this.$toast('请输入姓名')
        return
      }
      if (!this.phone) {
        this.$toast('请输入手机号')
        return
      }
      // const reg = /^0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/
      // if (!reg.test(this.phone)) {
      //   this.$toast('请输入正确的手机号')
      //   return
      // }
      if (!this.province || !this.city || !this.area || !this.town) {
        this.$toast('请选择地址')
        return
      }
      this.detailedAddress = this.detailedAddress.replace(/\s/g, '')
      if (!this.detailedAddress) {
        this.$toast('请输入详细地址')
        return
      }
      this.addrShow = false
      this.addrRecord = {
        contacts: this.contacts,
        phone: this.phone,
        province: this.province,
        city: this.city,
        area: this.area,
        town: this.town,
        detailedAddress: this.detailedAddress,
        province_code: this.province_code,
        city_code: this.city_code,
        area_code: this.area_code,
        town_code: this.town_code
      }
      localStorage.setItem('addr', JSON.stringify(this.addrRecord))
    },
    // 添加备注
    addRemark() {
      this.remarkShow = true
      if (this.remarkText) {
        this.remark = this.remarkText
      } else {
        this.remark = ''
      }
    },
    // 提交填写的备注
    sumbitRemark() {
      this.remarkText = this.remark
      this.remarkText = this.remarkText.replace(/\s/g, '')
      this.remarkShow = false
      localStorage.setItem('remarkText', this.remark)
    },
    // 提交所有数据
    sumbitAll() {
      if (this.goodList.length === 0) {
        this.$toast('请添加商品')
        return
      }
      if (!this.contacts || !this.phone || !this.address) {
        this.$toast('请添加地址')
        return
      }
      this.goodList.forEach((v) => {
        v.count = Number(v.count)
        delete v.productid
        delete v._id
        delete v.thumbnail
        delete v.skuname
        delete v.name
      })
      if (this.oagentId === 'undefined') {
        this.oagentId = ''
        this.oname = ''
        this.ophone = ''
      }
      let data = {
        province: this.province,
        city: this.city,
        area: this.area,
        town: this.town,
        addr: this.detailedAddress,
        contacts: this.contacts,
        phone: this.phone,
        order_agent_id: this.oagentId || '',
        remark: this.remarkText,
        order_name: this.oname || '',
        order_phone: this.ophone || '',
        total: this.totalPrice,
        union_id: this.$route.query.unionid || '',
        head_img_url: this.$route.query.head_img_url || '',
        nickname: this.$route.query.nick_name || '',
        name: this.name,
        agent_phone: this.phones,
        agent_id: this.agentId,
        pay_pass: '',
        product_list: this.goodList,
        province_code: this.province_code,
        city_code: this.city_code,
        area_code: this.area_code,
        town_code: this.town_code
      }
      this.loading = true
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      })
      this.totalPrices = this.totalPrice
      http.post('holiday/public/collect/order/add', data).then((res) => {
        if (res.code === 0) {
          Toast.clear()
          this.loading = false
          Toast.clear()
          this.loading = false
          this.goodList = []
          this.succeeds = true
          // this.address = ''
          this.remarkText = ''
          this.focusIndex = null

          this.totalPrice = 0
          // this.contacts = ''
          // this.phone = ''
          // this.detailedAddress = ''
          // this.addrRecord = {}

          this.localStorage.removeItem('remarkText')
          localStorage.removeItem('goodList')
        } else {
          Toast.clear()
          this.loading = false
          this.errmessage = res.message
          this.errds = true
        }
        // localStorage.clear()
      })
    },
    // ios手机频繁滑动后会出现页面假死的bug
    iosScrollFix(className) {
      var startY, startTopScroll
      var ua = navigator.userAgent.toLowerCase()
      if (/iphone|ipad|ipod/.test(ua)) {
        var temp = document.querySelectorAll(className)
        var tempLen = temp.length
        for (var i = 0; i < tempLen; ++i) {
          let j = i
          temp[j].addEventListener(
            'touchstart',
            function (event) {
              startY = event.touches[0].pageY
              startTopScroll = temp[j].scrollTop
            },
            false
          )
          temp[i].addEventListener('touchmove', function (event) {
            var startY2 = event.touches[0].pageY
            if (startTopScroll <= 0 && startY2 - startY > 0) {
              event.preventDefault()
            }
            if (
              startTopScroll + temp[j].offsetHeight >= temp[j].scrollHeight &&
              startY2 - startY < 0
            ) {
              event.preventDefault()
            }
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// @import url("../../assets/modifyvant.less");
body,
html {
  background-color: #f5f6fa;
}
.van-dialog {
  top: 48%;
}
.navigations {
  position: fixed;
  width: 100%;
  z-index: 9999;
  background-color: white;
  ul {
    display: flex;
    justify-content: space-around;

    li {
      position: relative;
      -webkit-tap-highlight-color: transparent;
      line-height: 40px;
      text-align: center;
      &:before {
        display: inline-block;
        content: '';
        width: 20px;
        height: 4px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
      }
      &.active {
        color: #222222;
        font-weight: bold;
        // font-weight: 900;
        &:before {
          display: block;
          height: 3px;
          background-color: #4380f1;
          border-radius: 8px;
        }
      }
    }
  }

  .agentList {
    padding: 0.5em;
  }
  .me_nav {
    background-color: white;
    position: relative;
    ul {
      display: flex;
      justify-content: space-evenly;
      padding-top: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      .actives {
        font-weight: bold;
      }
      li {
        line-height: 26px;
      }
    }
    .searchs {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 26px;
      height: 26px;
      box-sizing: border-box;
      padding-top: 5px;
      padding-left: 4px;
      border-radius: 50%;
      box-shadow: 0px 2px 5px #d1d1d1;
      img {
        width: 18px;
        height: 18px;
      }
    }
  }
}
.login-wrapper {
  background-color: #f5f6fa;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.caredily-symbol {
  margin-top: 40px;
}
.agent_msg {
  padding: 16px 20px;
  // margin-top: 20px;
  // margin-bottom: 10px;
  // background-color: #9999;
  background-image: url('../image/Bj@2x.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  .name {
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 4px;
    }
    span {
      font-size: 18px;
      font-weight: bold;
      color: #222222;
    }
  }
  .agentid {
    font-size: 16px;
    color: #222;
    opacity: 0.6;
    margin-left: 8px;
    margin-top: 4px;
  }
  .phone {
    color: #666;
    display: block;
    margin-top: 4px;
    font-size: 12px;
  }

  .tabs {
    background-image: linear-gradient(to left, #fe7459, #ff2a42);
    padding: 0.1em 0.3em;
    color: white;
    font-size: 10px;
    border-radius: 2px;
    margin-top: 2px;
    float: right;
    margin-left: 5px;
    // display: block;
  }
}
.wrapper {
  .caredily-symbol {
    width: 100%;
    .c-pirture {
      margin: 0 auto;
      width: 100%;
      height: 100%;
      background: #222;
      display: flex;
      img {
        width: 100%;
      }
    }
  }

  .receipt-content {
    top: 110px;
    z-index: 0;
    background-color: #fff;
    position: absolute;
    // top: 188px;
    padding: 20px 20px 80px 20px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    width: 100%;
    .goods,
    .address,
    .remark {
      margin-bottom: 24px;
      h3 {
        font-size: 16px;
        margin-bottom: 13px;
      }
      .add-button {
        width: 100%;
        height: 66px;
        border: 1px dashed #999;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        img {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }
      }
    }
    .goods {
      .good-list {
        li {
          // height: 92px;
          margin-bottom: 12px;
          border-radius: 10px;
          padding: 6px 12px 6px 6px;
          background: #fff;
          // box-shadow: 1px 3px 4px 4px rgba(247, 241, 241, 0.5);
          display: flex;
          box-sizing: border-box;
          // align-items: center;
          position: relative;
          .sku_pirce_txt {
            color: #222;
            line-height: 25px;
          }
          .sku_pirce {
            display: flex;
            margin-top: 18px;
            width: 100%;
            justify-content: space-between;
          }
          .sku-num {
            text-align: right;
            display: flex;
            label {
              display: block;
              width: 22px;
              height: 22px;
              border: 1px dotted #000;
              text-align: center;
              line-height: 20px;
              font-size: 16px;
            }
          }
          i {
            // position: absolute;
            // right: 15px;
            // top: 17px;
            display: block;
            width: 26px;
            height: 26px;
            background: url('../image/sc@2x.png') no-repeat;
            background-size: contain;
          }
          .good-img {
            width: 80px;
            img {
              display: block;
              width: 80px;
              height: 80px;
              border-radius: 6px;
            }
          }
          .good-msg {
            flex: 1;
            margin-left: 12px;
            // padding: 10px 0;
            .good-name {
              font-size: 14px;
              padding-right: 50px;
            }
            .good-num {
              font-size: 12px;
              color: #999;
              margin-top: 8px;
              p {
                display: flex;
                justify-content: space-between;
                .sku-name {
                  // width: 140px;
                  width: 3.2rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .sku-num {
                  // text-align: right;
                  width: 75px;
                  padding-right: 5px;
                }
              }
              b {
                font-size: 14px;
                line-height: 22px;
                font-weight: normal;
                color: #000;
                margin-right: 6px;
                margin-left: 6px;
              }
            }
          }
        }
      }
    }
    .address {
      .address-msg {
        width: 100%;
        min-height: 71px;
        background: #fff;
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding: 0 15px 0 20px;
        box-shadow: 1px 3px 4px 4px rgba(247, 241, 241, 0.5);
        .left {
          display: block;
          width: 22px;
          height: 23px;
          background: url('../image/Dz@2x.png') no-repeat;
          background-size: contain;
          margin-right: 20px;
        }
        .msg {
          flex: 1;
          p {
            &:nth-child(1) {
              font-size: 14px;
              display: flex;
              justify-content: space-between;
              color: #000000;
            }
            &:nth-child(2) {
              margin-top: 5px;
              font-size: 12px;
              color: #999999;
            }
            input {
              font-size: 14px;
            }
          }
        }
        .right {
          display: block;
          width: 8px;
          height: 12px;
          background: url('../image/1@2x.png') no-repeat;
          background-size: contain;
          margin-left: 20px;
        }
      }
    }
    .remark-text {
      width: 100%;
      background: #fff;
      padding: 15px 12px;
      border-radius: 8px;
      overflow: hidden;
      white-space: normal;
      word-break: break-all;
      text-overflow: ellipsis;
    }
  }
}
.fixed-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px 30px;
  height: 62px;
  background: #fff;
  box-shadow: 1px 3px 4px 4px rgba(247, 241, 241, 0.5);
  span {
    height: 46px;
    line-height: 46px;
  }
  button {
    height: 48px;
    line-height: 48px;
  }
  span,
  button {
    display: block;
    width: 100%;
    text-align: center;
    background: #628ed7;
    border-radius: 30px;
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    position: relative;
    z-index: 1000;
    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      right: 50%;
      bottom: 50%;
      width: 100%;
      height: 100%;
      background: #000;
      border: inherit;
      border-color: #000;
      border-radius: 30px;
      transform: translate(-50%, -50%);
      opacity: 0;
      content: '';
    }
    &:active::before {
      opacity: 0.2;
    }
  }
}

.btn_flex {
  padding: 8px 10px;
  display: flex;
  justify-content: space-between;
  .total_price {
    display: flex;
    font-size: 12px;
    color: #222;
    margin-top: 16px;
    p {
      font-weight: bold;
      display: flex;
      label {
        font-size: 20px;
        display: flex;
        margin-top: -3px;
      }
    }
  }
  .van-button {
    width: 40%;
  }
}

.me_con {
  .orderList {
    padding: 0.8em;
    margin-top: 110px;
    ul {
      li {
        position: relative;
        padding: 1.2em;
        background-color: white;
        border-radius: 10px;
        margin-bottom: 10px;
        .lines {
          display: block;
          width: 4px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 26px;
          border-radius: 0px 3px 3px 0px;
          background-color: #333a54;
        }
        .order_num {
          padding-bottom: 10px;
          border-bottom: 1px solid #f5f6fa;
        }
        .numbers {
          display: flex;
          font-size: 12px;
          justify-content: space-between;
          .numbers_txt {
            display: flex;
            .texts {
              font-weight: bold;
            }
            .text_num {
              margin-top: 2px;
              display: block;
            }
          }

          img {
            width: 6px;
            height: 10px;
            margin-top: 3px;
            margin-left: 5px;
          }
        }
        .order_time {
          margin-top: 5px;
          font-size: 11px;
          color: #666666;
        }
        .oeder_addres {
          display: flex;
          margin-top: 12px;
          .address_img {
            width: 20px;
            margin-top: 5px;
            img {
              width: 20px;
              height: 20px;
            }
          }
          .addres_txts {
            .address_con {
              display: flex;
              font-size: 14px;
              font-weight: bold;
              padding-bottom: 10px;
              border-bottom: 1px solid #f5f6fa;
              img {
                width: 10px;
                height: 12px;
                display: block;
                margin-right: 5px;
                margin-top: 4px;
              }
            }
          }
        }
        .order_btn {
          display: flex;
          justify-content: flex-end;
          margin-top: 10px;
          .van-button--default {
            border-radius: 20px;
            border: 1px solid #e2e2e2;
            width: 100px;
            height: 38px;
          }
          .logistics {
            margin-left: 10px;
            border: 1px solid #4380f1;
            color: #4380f1;
          }
        }
        .refuse {
          margin-top: 10px;
          background-color: #f5f6fa;
          color: #fb524d;
          // padding-top: 11px;
          padding: 0.6em;
          border-radius: 10px;
          font-size: 12px;
          p {
            padding-bottom: 5px;
          }
          .refuse_time {
            color: #222;
          }
        }
        .colonel {
          margin-top: 12px;
          display: flex;
          .colonel_name {
            font-size: 16px;
            color: #222;
            font-weight: bold;
            // margin-top: -2px;
            display: block;
          }
          .colonel_tag {
            margin-left: 8px;
            background-image: linear-gradient(to left, #fe7459, #ff2a42);
            color: white;
            padding: 0em 0.4em;
            border-radius: 2px;
            height: 18px;
            line-height: 18px;

            font-size: 10px;
          }

          .colonel_phone {
            margin-left: 20px;
            font-size: 13px;
            color: #222;
            margin-top: 2px;
          }
        }
        .me_colonel {
          .colonel_tag {
            background-image: linear-gradient(to left, #b4d1f8, #4e7cc6);
          }
        }
        .logistics_list {
          margin-top: 15px;
          .logisticsList {
            margin-top: 10px;
          }
          .logisticsTitle {
            display: flex;
            font-size: 14px;
            justify-content: space-between;
            .logisticsName {
              display: flex;
              label {
                display: list-item;
                list-style-type: disc;
                margin-left: 0.5em;
                font-size: 14px;
                font-weight: bold;
                margin-right: 10px;
              }
            }
            .copy_logistics {
              color: #4380f1;
              font-size: 13px;
              margin-top: 2px;
            }
          }

          .logistics_msg {
            margin-top: 12px;
            background-color: #f5f6fa;
            padding: 0.5em;
            border-radius: 10px;
            .logistics_line {
              width: 100%;
              height: 3px;
              margin-top: -0.4em;
              // margin-left: -5px;
              border-radius: 10px;
              display: flex;
              span {
                display: block;
                background-color: f5f6fa;
                border-radius: 10px;
                width: 5%;
              }
              .reds {
                background-color: #ff2c42;
              }
              .blues {
                background-color: #568df3;
              }
            }
            .logistics_list_con {
              margin-top: 14px;
              margin-bottom: 10px;
              font-size: 12px;
              font-weight: bold;
              p {
                margin-top: 5px;
                font-size: 11px;
                color: #666;
              }
            }
          }
        }
      }
    }
  }
}

.subordinate {
  text-align: center;
  font-size: 14px;
  padding-top: 40px;
  img {
    width: 60%;
    margin: 0 auto;
  }
}
.more-w {
  text-align: center;
  font-size: 12px;
  padding-bottom: 20px;
}
.popupBox {
  // width: 100%;
  padding: 0 20px;
  // height: 10rem;
  // overflow: scroll;
  // background: #fff;
  // -webkit-overflow-scrolling: touch;
  h2 {
    font-size: 0.32rem;
    height: 1.26rem;
    line-height: 1.26rem;
  }
  .searchText {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #f3f4f6;
    border-radius: 20px;
    position: relative;
    padding-left: 16px;
    i {
      display: block;
      width: 0.34rem;
      height: 0.34rem;
      background: url('../image/serch.png') no-repeat;
      background-size: contain;
      position: absolute;
      left: 12px;
      top: 8px;
    }
    input {
      width: 100%;
      height: 100%;
      padding-left: 16px;
      border-radius: 20px;
      background: #f3f4f6;
    }
  }
  .product {
    h4 {
      font-size: 12px;
      color: #999;
      font-weight: normal;
      line-height: 46px;
      margin-top: -10px;
    }
    .product-list {
      li {
        border-bottom: 1px solid #f2f2f5;
        display: flex;
        align-items: center;
        padding: 16px 0;
        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          border-bottom: none;
        }
        .checked {
          i {
            display: block;
            width: 18px;
            height: 18px;
            background: url('../image/check.png') no-repeat;
            background-size: contain;
            &.nocheck {
              display: block;
              width: 18px;
              height: 18px;
              background: url('../image/nocheck.png') no-repeat;
              background-size: contain;
            }
          }
        }
        img {
          width: 80px;
          height: 80px;
          border-radius: 5px;
          margin: 0 12px;
        }
        .product-msg {
          flex: 1;
          .product-name {
            font-size: 14px;
          }
          .product-sub {
            color: #999;
            margin-top: 8px;
          }
        }
      }
    }
  }
  // sku弹窗样式
  .title {
    height: 1.26rem;
    line-height: 1.26rem;
    font-size: 0.32rem;
    text-align: center;
    position: relative;

    i {
      display: block;
      width: 18px;
      height: 18px;
      background: url('../image/Gb@2x.png') no-repeat;
      background-size: contain;
      position: absolute;
      right: 10px;
      top: 22px;
    }
  }
  .product-img {
    display: flex;
    align-items: center;
    img {
      width: 90px;
      height: 90px;
      border-radius: 5px;
      margin-right: 10px;
    }
    p {
      flex: 1;
      font-size: 14px;
    }
    .product_pirce {
      color: #ff4446;
      margin-top: 10px;
    }
  }
  .product-sku {
    margin-top: 30px;
    p {
      font-size: 14px;
      font-weight: bold;
    }
    .sku-list {
      display: flex;
      flex-wrap: wrap;
      margin: 20px 0 15px;
      li {
        padding: 5px 15px;
        font-size: 12px;
        background: #f5f6fa;
        border-radius: 20px;
        margin-right: 15px;
        margin-bottom: 15px;
        border: 1px solid #ececec;
        &.active {
          color: #628ed7;
          border: 1px solid #628ed7;
        }
      }
    }
  }
  .product-num {
    display: flex;
    justify-content: space-between;
    .text {
      font-size: 14px;
      font-weight: bold;
    }
    .operation {
      width: 90px;
      display: flex;
      .reduce {
        background: url('../image/subtracttwo1@2x.png') no-repeat;
        background-size: contain;
        margin-right: 4px;
      }
      .add {
        background: url('../image/plus@2x.png') no-repeat;
        background-size: contain;
        margin-left: 4px;
      }
      i {
        display: block;
        width: 20px;
        height: 20px;
      }
      input {
        width: 40px;
        border-radius: 4px;
        background: #f5f8fb;
        text-align: center;
      }
    }
  }
  // 填写地址弹窗样式
  .addr-input {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    background: #f2f2f5;
    border: 1px solid #f2f2f5;
    margin-bottom: 12px;
    border-radius: 8px;
    &.active {
      background: rgba(98, 142, 215, 0.12);
      border: 1px solid #628ed7;
      input {
        background: rgba(98, 142, 215, 0.01);
      }
    }
    span {
      width: 90px;
      font-size: 14px;
      padding-left: 20px;
    }
    input {
      flex: 1;
      height: 100%;
      background: #f2f2f5;
      border-radius: 8px;
    }
  }
  .addr-input-choose {
    width: 100%;
    min-height: 48px;
    display: flex;
    align-items: center;
    background: #f2f2f5;
    border: 1px solid #f2f2f5;
    margin-bottom: 12px;
    border-radius: 8px;
    &.active {
      background: rgba(98, 142, 215, 0.12);
      border: 1px solid #628ed7;
      .input {
        background: rgba(98, 142, 215, 0.01);
      }
    }
    span {
      width: 90px;
      font-size: 14px;
      padding-left: 20px;
    }
    .input {
      padding-left: 0;
      flex: 1;
      height: 100%;
      // line-height: 50px;
      color: #999999;
      background: #f2f2f5;
      border-radius: 8px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }
    i {
      margin-right: 16px;
      display: block;
      width: 8px;
      height: 12px;
      background: url('../image/1@2x.png') no-repeat;
      background-size: contain;
    }
  }
  .addr-input-del {
    width: 100%;
    height: 163px;
    background: #f2f2f5;
    border: 1px solid #f2f2f5;
    border-radius: 8px;
    padding: 15px 15px 10px 20px;
    &.active {
      background: rgba(98, 142, 215, 0.12);
      border: 1px solid #628ed7;
      textarea {
        background: rgba(98, 142, 215, 0.01);
      }
    }
    p {
      font-size: 14px;
    }
    textarea {
      font-size: 14px;
      width: 100%;
      height: 90%;
      background: #f2f2f5;
      padding: 15px 0 10px 0;
    }
  }
  // 级联地址选择弹窗
  .address-content2 {
    font-size: 12px;
    display: flex;
    .address-box {
      height: 8rem;
      margin-right: 5px;
      padding-bottom: 80px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      &::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #333;
      }
      &::-webkit-scrollbar-corner {
        background: #179a16;
      }
      .address-item {
        height: 0.68rem;
        line-height: 0.68rem;
        &.active {
          color: #53acfe;
        }
        span {
          display: block;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &.first {
        width: 110px;
        position: relative;
        top: 0;
      }
      &.two {
        flex: 1;
      }
      &.three {
        width: 90px;
      }
      .ceshis {
        width: 100%;
        height: 50px;
      }
    }
  }
  // 备注弹窗样式
  .remark-title {
    display: flex;
    justify-content: space-between;
  }
  .remark-input-del {
    width: 100%;
    height: 260px;
    background: #f2f2f5;
    border-radius: 8px;
    padding: 0 15px 10px 20px;
    textarea {
      font-size: 14px;
      width: 100%;
      height: 90%;
      background: #f2f2f5;
      padding: 20px 0 10px 0;
    }
  }
}

.order_pop {
  .title {
    text-align: left;
  }
  .order_detail {
    li {
      display: flex;
      margin-bottom: 20px;
      border-bottom: 1px solid #f2f2f5;
      padding-bottom: 20px;

      .shopimg {
        width: 90px;
        height: 80px;
        padding-right: 5px;
        background-color: #f2f2f6;
        border-radius: 6px;

        img {
          width: 70px;
          height: 70px;
          margin-top: 5px;
          margin-left: 5px;
        }
      }

      .order_detail_con {
        color: #222;
        .shop_name {
          font-size: 15px;
        }
        margin-left: 10px;
        .specification {
          font-size: 12px;
          color: #666;
          margin-top: 8px;
          margin-bottom: 8px;
        }
        .shop_pirce {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
        }
      }
    }
  }
}

.logistics_pop {
  background-color: #f5f6fa;
  .expressage {
    display: flex;
    justify-content: space-between;
    background-image: linear-gradient(to left, #40465f, #29304a);
    padding: 0.8em;
    border-radius: 10px;
    padding-bottom: 30px;
    color: white;
    .expressage_txt {
      display: flex;
      font-size: 14px;
      .expressage_name {
        color: #f5f6fa;
        display: flex;
        .lines {
          display: block;
          border: 1px solid #f5f6fa;
          margin-left: 6px;
          margin-right: 6px;
          height: 12px;
          margin-top: 4px;
        }
      }
      .expressage_nums {
        margin-top: 2px;
        margin-left: 5px;
      }
    }
  }
  .order_detail {
    background-color: white;
    padding: 0.8em;
    margin-top: -20px;
    border-radius: 10px;
    li {
      padding-bottom: 0;
      border: none;
    }
  }
  .stalker_title {
    font-size: 13px;
    color: #222;
    font-weight: bold;
  }

  .step {
    width: 100%;
    padding: 0 8px;
    box-sizing: border-box;
    height: auto;
    border-radius: 5px;

    h3 {
      margin: 0;
      font-size: 13px;
      color: #222;
    }

    p {
      margin: 0;
      padding: 10px;
      padding-top: 0;
      font-size: 12px;
      color: #666;
    }
  }
  .van-step__title {
    color: #222222;
    font-size: 13px;
  }
}
.van-popup {
  border-radius: 20px 20px 0 0;
  .order_amount {
    position: fixed;
    bottom: 0;
    width: 100%;
    font-size: 12px;
    height: 40px;
    line-height: 40px;
    background-color: white;
    span {
      label {
        font-size: 12px;
      }
    }
    label {
      font-size: 20px;
      color: #222;
      font-weight: bold;
    }
  }
}

.stepes {
  i {
    color: #000;
  }
}
.search_result {
  width: 100%;
  .search_result_back {
    background-color: white;
    justify-content: space-between;
    display: flex;
    padding: 0.4em;
    color: #222;
    .search_result_conten {
      font-size: 12px;
      display: flex;
      .search_lins {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #4380f1;
        display: block;
        margin-top: 5px;
        margin-right: 6px;
      }
      .search_result_record {
        margin-left: 20px;
        display: block;
      }
    }
    p {
      font-size: 13px;
    }
  }
}
@media screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) {
  .good-num {
    .sku-name {
      width: 2.8rem !important;
    }
    .sku-num {
      width: 60px !important;
    }
  }
}

select {
  background-color: white;
}
//  提交订单弹框
.showtan {
  i {
    display: block;
    width: 18px;
    height: 18px;
    background: url('../image/Gb@2x.png') no-repeat;
    background-size: contain;
    position: absolute;
    right: 10px;
    top: 22px;
  }
  padding: 1em;
  text-align: center;
  div {
    line-height: 30px;
  }

  .hitsucceed_txt {
    color: #222222;
    font-size: 18px;
  }
  .hit_txt {
    color: #222222;
    font-size: 14px;
  }

  .title {
    font-size: 18px;
    color: #222;
    text-align: center;
    position: relative;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
    span {
      position: absolute;
      top: 0;
      right: 0;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .img_con {
    width: 50%;
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;

    img {
      width: 100%;
      top: -100px;
    }
  }
  .show_btn {
    display: flex;
    justify-content: space-between;
    .van-button {
      width: 45%;
      border-radius: 20px;
      background-color: white;
      border: 1px solid #4380f1;
      color: #4380f1;
    }
    .file_updates {
      width: 45%;
      position: relative;
      .file_update {
        // width: 100px;
        // margin-left: -50px;
        position: absolute;
        z-index: 999;
        margin-top: 10px;
        opacity: 0;
      }
      .update {
        width: 100%;
        background-color: #4380f1;
        color: white;
      }
    }
  }
  .titles {
    font-weight: bold;
  }
  .show_btns {
    margin-top: 20px;
    .van-button {
      width: 60%;
      border-radius: 20px;
      background-color: #4380f1;
      color: white;
    }
  }
}
.searchPopups {
  padding: 0em 0.5em;
  padding-bottom: 20px;
  .search_con {
    display: flex;
    padding-bottom: 2px;
    border-bottom: 1px solid #d4d4d4;
    select {
      appearance: auto;
    }
  }
  .search_btnBox {
    margin-top: 40px;
    .van-button {
      width: 100%;
      background-color: #4380f1;
      border: none;
      color: white;
      font-size: 16px;
      border-radius: 20px;
    }
  }
}
</style>

<style lang="scss">
.stepes {
  .van-step__icon--active,
  .van-step__icon--finish,
  .van-step__title--active,
  .van-step__title--finish {
    color: rgba(67, 128, 241, 0.8);
  }
}
.examine {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  i {
    display: block;
    width: 15px;
    height: 15px;
    border: 1px solid;
  }
}
</style>